import { type TermsMethodsKindEnum } from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
import { CreateTermOrMethodForm } from '@webapp/modules/purchasing/features/create-term-or-method/views/CreateTermOrMethodForm'
import { useCreateTermOrMethodFormPresenter } from './useCreateTermOrMethodFormPresenter'

export interface ICreateTermOrMethodFormPresenterProps {
  kind: TermsMethodsKindEnum
  onSuccess: (id: number) => void
  onCancel: () => void
}

export const CreateTermOrMethodFormPresenter = ({
  kind,
  onSuccess,
  onCancel,
}: ICreateTermOrMethodFormPresenterProps) => {
  const {
    states: { isSaving },
    handlers: { handleSubmit },
  } = useCreateTermOrMethodFormPresenter({ kind, onSuccess })

  return (
    <CreateTermOrMethodForm
      kind={kind}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSaving={isSaving}
    />
  )
}

CreateTermOrMethodFormPresenter.displayName = 'CreateTermOrMethodFormPresenter'
